<template>
	<div style="width: 1000px;margin: 70px auto;">
		<bar :show="true" :totalMoney="money" :activity="activityId" :activityName="activityName" :activityLimit="activityLimit" :surplusLimit="surplusLimit"></bar>
		<div class="vehicle-box">
			<div class="vehicle-span">
				<span>活动限额：{{ activityLimit }}&nbsp;,&nbsp;活动剩余：{{ surplusLimit }}</span>
			</div>
		</div>
		<div class="zt-z">
			<span>{{ activityName }}</span>
		</div>
		<br>

		<div style="width: 1000px;margin:0 auto;text-align: left;">
			<!-- <el-form :inline="true"  class="demo-form-inline">
				<el-form-item label="">
					<el-radio-group @change="toQuery" v-model="productType">
						<el-radio-button label="0">全部</el-radio-button>
						<el-radio-button v-for="(item) in categoryList" :key="item.id" :label="item.id">{{item.categoryName}}</el-radio-button>
					</el-radio-group>
				</el-form-item>
			</el-form> -->
			<el-form @submit.native.prevent :inline="true"  class="demo-form-inline">
				<el-form-item label="SKU Code">
					<el-input @keyup.native.enter="fetchProductData" style="width:420px;" v-model="skucode"></el-input>
				</el-form-item>
				<el-form-item label="有货">
					<el-checkbox v-model="checked"></el-checkbox>
				</el-form-item>
				<el-form-item style="float:right;">
					<el-button @click="fetchProductData" type="primary">查询</el-button>
					<el-button @click="reset" type="primary">重置</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div style="width: 1000px;height: 30px; margin-top: 20px;;border-bottom: 1px solid #000000;"><span style="font-size: 14px;float: left">首页/商品列表</span></div>

		<div class="allbox">
			<div v-for="(item) in list" :key="item.id" class="middle-box">
				<div @click="toDetail(item)" class="middle-box-div">
					<span class="middle-box-bar"></span>
					<img :src="$store.getters.imageUrl + '/' + item.productImgPath" alt="" />
				</div>
				<div>
					<div class="middle-box-new">
						<div style="text-align:left;margin-top:5px;">
							<span>{{ item.productName }}</span>
						</div>
						<!-- <div style="text-align:left;margin-top:5px;">
							<span>{{ item.productNameEn }}</span>
						</div> -->
						<!-- <div style="text-align:left;margin-top:5px;">
							<span>{{ item.categoryName }}</span>
						</div> -->
						<div style="text-align:left;margin-top:5px;">
							<span>市场价</span>
							<span style="float: right;text-decoration: line-through;">￥{{ item.salePrice }}</span>
						</div>
						<div style="text-align:left;margin-top:5px;">
							<span>福豆数</span>
							<span style="float: right;">{{ item.activityPrice }}</span>
						</div>
						<div style="text-align:left;margin-top:5px;">
							<span>限购数量</span>
							<span style="float: right;">{{ item.limitCount }}件</span>
						</div>
					</div>
				</div>
				<div style="margin: 10px 0 0 77px;width: 250px;text-align: left;">
					<el-input-number :min="1" :max="item.limitCount<item.surplusCount?item.limitCount:item.surplusCount" style="width:100px;" size="mini" v-model="item.count"></el-input-number>&nbsp;&nbsp;
					<el-button :disabled="item.surplusCount===0" @click="addCar(item)" id="gouwuche" size="mini">加入购物车</el-button>
				</div>
			</div>
		</div>
		<div class="pagination-container">
			<el-pagination background :page-size="12" @current-change="handleCurrentChange" :current-page="index" layout="total, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import bar from '@/components/bar.vue'
import { productList, productCategory, saveCarInfo,carMoney } from '../api/service'

export default {
	data() {
		return {
			activityId: '',
			activityName: '',
			activityLimit: '',
			surplusLimit: '',
			productType: '0',
			skucode: '',
			list: null,
			categoryList: null,
			index: 1,
			size: 12,
			total: 0,
			money: 0,
			checked: false
		};
	},
	methods: {
		reset () {
		  this.checked = false
		  this.skucode = ''
		  this.productType = '0'
		  this.fetchData()
		},
		toQuery (val) {
			this.index = 1
			const params = {
				page_index: this.index,
				page_size: this.size,
				categoryId: val === '0' ? '': val.toString(),
				skuCode: this.skucode,
				activityId: this.activityId,
				inStock: this.checked
			}
			productList(params).then(response => {
				if (response.data.success === true) {
					this.list = response.data.data.list
					this.total = response.data.data.total
					this.$nextTick(() => {
						for (let index = 0; index < this.list.length; index++) {
							this.list[index].count = 1
						}
					})
				} 
			}).catch(() => {
				this.list = null
			})
		},
		fetchData () {
			const params = {
				page_index: this.index,
				page_size: this.size,
				categoryId: this.productType === '0' ? '': this.productType,
				skuCode: this.skucode,
				activityId: this.activityId,
				inStock: this.checked
			}
			productList(params).then(response => {
				if (response.data.success === true) {
					this.list = response.data.data.list
					this.total = response.data.data.total
					this.$nextTick(() => {
						for (let index = 0; index < this.list.length; index++) {
							this.list[index].count = 1
						}
					})
				} 
			}).catch(() => {
				this.list = null
			})
		},
		fetchCategory () {
			productCategory().then(response => {
				if (response.data.success === true) {
					this.categoryList = response.data.data
				} 
			}).catch(() => {
			})
		},
		fetchProductData () {
			this.index = 1
			const params = {
				page_index: this.index,
				page_size: this.size,
				categoryId: this.productType === '0' ? '': this.productType,
				skuCode: this.skucode,
				activityId: this.activityId,
				inStock: this.checked
			}
			productList(params).then(response => {
				if (response.data.success === true) {
					this.list = response.data.data.list
					this.total = response.data.data.total
					this.$nextTick(() => {
						for (let index = 0; index < this.list.length; index++) {
							this.list[index].count = 1
						}
					})
				} 
			}).catch(() => {
				this.list = null
			})
		},
		toDetail (item) {
			const para = {
				activityId: this.activityId,
				productId: item.id,
				activityName: this.activityName,
				activityLimit: this.activityLimit,
				surplusLimit: this.surplusLimit
			}
			this.$router.push({ path: 'introduce', query: para })
		},
		handleCurrentChange(val) {
			this.index = val
			this.fetchData()
		},
		getTotal () {
			const params1 = {
				activityId: this.activityId,
				staffId: this.$store.getters.id
			}
			carMoney(params1).then(response => {
				if (response.data.success === true) {
					this.money = response.data.data
				} 
			}).catch(() => {
			})
		},
		addCar (item) {
			const params = {
				staffId: this.$store.getters.id,
				activityId: this.activityId,
				productId: item.id,
				buyCount: item.count
			}
			saveCarInfo(params).then((response) => {
				if (response.data.success === true) {
					this.getTotal()
				} else {
					this.$alert('添加失败', '提示', {
						confirmButtonText: '确定',
					});
				}
			}).catch(() => {
					this.$message({ type: 'warning', message: '添加失败!' })
			})
		}
	},
	created() {
		this.activityId = this.$route.query.activityId
		this.activityName = this.$route.query.activityName
		this.activityLimit = this.$route.query.activityLimit
		this.surplusLimit = this.$route.query.surplusLimit
		this.fetchData()
		this.fetchCategory()
	},
	components: {
		bar
	}
};
</script>

<style scoped="">
.clearfix:after {
	content: '';
	clear: both;
	display: block;
}
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 300px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	position: absolute;
	top: 3px;
	right: 90px;
}
a {
	text-decoration: none;
}
.allbox {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 100px;
}
.middle-box {
	width: 309px;
	margin-top: 20px;
}
.middle-box img {
	width: 200px;
	height: 200px;
}
.zt-z {
	/* width: 250px; */
	margin-right: 72%;
	height: 42px;
	background-color: #be0f34;
}
.zt-z span {
	line-height: 42px;
	text-align: center;
	color: white;
	font-family: '黑体' !important;
}
.details {
	width: 100px;
	height: 30px;
	position: relative;
	left: 600px;
	bottom: 50px;
	display: inline-block;
}
.block {
	margin-top: 105px;
}
.vehicle-box {
	padding: 0px 15px;
	height: 42px;
	float: right;
	background-color: #be0f34;
	color: white;
}
.vehicle-span {
	line-height: 42px;
	text-align: center;
	color: white;
	font-family: '黑体' !important;
}
.middle-box-bar {
	width: 230px;
	height: 10px;
	background-color: #be0f34;
	float: left;
}
.middle-box-div {
	float: left;
	margin-left: 78px;
	width: 230px;
	height: 210px;
	border: 1px solid #e5e5e5;
	display: inline-block;
}
/* .middle-box div {
	display: inline-block;
} */
.middle-box-font {
	margin: 10px 0 0 77px;
	width: 250px;
	font-size: 13px;
	color: #be0f34;
}
.middle-box-new {
	margin: 10px 0 0 77px;
	font-size: 13px;
	width: 230px;
	color: #be0f34;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
}
.middle-box-fontt {
	font-size: 13px;
	color: #be0f34;
	margin-left: -2px;
}
#gouwuche {
	background-color: #be0f34;
	color: white;
	padding-left: 5px;
	padding-right: 5px;
	margin-left: 10px;
}
</style>
